
ADILF.define('streamhub-sdk/content/types/type-urns',['require','exports','module'],function (require, exports, module) {var TYPE_URNS = {
    LIVEFYRE_TWITTER:   'urn:livefyre:js:streamhub-sdk:content:types:livefyre-twitter',
    LIVEFYRE_FACEBOOK:  'urn:livefyre:js:streamhub-sdk:content:types:livefyre-facebook',
    LIVEFYRE_INSTAGRAM: 'urn:livefyre:js:streamhub-sdk:content:types:livefyre-instagram',
    TWITTER:            'urn:livefyre:js:streamhub-sdk:content:types:twitter',
    LIVEFYRE_URL:       'urn:livefyre:js:streamhub-sdk:content:types:livefyre-url',
    LIVEFYRE:           'urn:livefyre:js:streamhub-sdk:content:types:livefyre',
    CONTENT:            'urn:livefyre:js:streamhub-sdk:content'
};

module.exports = TYPE_URNS;

});
